<template>
  <component :is="$route.meta.layout || 'div'" style="background-color: #F4F5FA;">
    <router-view></router-view>
  </component>
  
  <!-- 전역 Snackbar -->
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    location="top"
    variant="elevated"
  >
    {{ snackbar.text }}
    <template v-slot:actions>
      <v-btn
        variant="text"
        @click="hideSnackbar"
      >
        닫기
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

// 스토어에서 snackbar 상태 가져오기 (안전한 기본값 제공)
const snackbar = computed(() => store.state.snackbar || {
  show: false,
  text: '',
  color: 'info',
  timeout: 3000
});

// snackbar 숨기기
const hideSnackbar = () => {
  store.commit('hideSnackbar');
};
</script>
